<template>
  <el-form
    :model="form"
    class="form-sing-up-step-code"
    :class="classes"
    ref="form"
    v-loading="isLoading"
    :disabled="isDisabled"
    @submit.native.prevent="submitForm()">
    <slot name="header"/>
    <div class="net-error-message" v-if="netError">
      {{netError}}
    </div>
    <el-form-item
      prop="code"
      :rules="getValidationRule('code')"
      class="keys-wrapper material-style"
      :class="{'net-error': (netError)}">
      <div class="keys">
        <el-input :value="form.key1"
                  @input="handleInput($event, 1)"
                  @keyup.right.native="focusField('code2')"
                  ref="code1"/>
        <el-input :value="form.key2"
                  @input="handleInput($event, 2)"
                  @keyup.delete.native="handleDelete(2)"
                  @keyup.left.native="focusField('code1')"
                  @keyup.right.native="focusField('code3')"
                  ref="code2"/>
        <el-input :value="form.key3"
                  @input="handleInput($event, 3)"
                  @keyup.delete.native="handleDelete(3)"
                  @keyup.left.native="focusField('code2')"
                  @keyup.right.native="focusField('code4')"
                  ref="code3"/>
        <el-input :value="form.key4"
                  @input="handleInput($event, 4)"
                  @keyup.delete.native="handleDelete(4)"
                  @keyup.left.native="focusField('code3')"
                  ref="code4"/>
      </div>
    </el-form-item>
    <div class="form-footer">
      <slot name="footer"/>
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'FormCode',
  props: {
    isDisabled: { type: Boolean, default: true },
    isLoading: { type: Boolean, default: false },
    classes: { type: String, default: '' },
    netError: { type: String, default: '' }
  },
  data () {
    return {
      deleteFlag: 0,
      form: {
        code: '',
        key1: '',
        key2: '',
        key3: '',
        key4: ''
      },
      debounceHandleCode: this.$_.debounce(this.handleCode, 100)
    }
  },
  methods: {
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('valid', this.form.code)
        } else {
          this.$emit('noValid')
        }
      })
    },
    handleInput (val, Num) {
      if (val && val.length > 2) {
        this.inputPaste(val, Num)
      } else {
        this.inputSingle(val, Num)
      }
    },
    inputPaste (val, Num) {
      val = val.replace(/\D/g, '')
      Array(4).fill(null).forEach((item, index) => {
        this.form[`key${index + 1}`] = val[index] || ''
      })
      this.focusSubmit()
      this.computedCodeAndCheck()
    },
    inputSingle (val, Num) {
      this.form[`key${Num}`] = this.formatValue(val, this.form[`key${Num}`])
      this.debounceHandleCode(Num)
    },
    handleDelete (Num) {
      if (this.deleteFlag === Num || (Num === 4 && !this.form[`key${Num}`])) {
        this.deleteFlag = 0
        this.focusField(`code${Num - 1}`)
      } else {
        this.deleteFlag = Num
      }
    },
    handleCode (Num) {
      // :TODO Go to next Element
      let val = this.form[`key${Num}`] = this.formatValue(this.form[`key${Num}`])
      if (val) {
        if (Num < 4) {
          this.form[`key${Num + 1}`] = ''
          this.focusField(`code${Num + 1}`)
        } else {
          this.focusSubmit()
        }
      }
      this.computedCodeAndCheck()
    },
    computedCodeAndCheck () {
      // :TODO Computed a code
      this.form.code = this.$_.reduce(this.form, (result, value, key) => {
        if (key !== 'code') result += value
        return result
      }, '')
      // :TODO Trick hide validate message if all input
      if (this.form.code.length === 4) this.$refs.form.validate()
    },
    formatValue (val, oldVal) {
      val = val.replace(/\D/g, '')
      val = String(val).split('').filter((n) => n !== oldVal).join('')
      return val
    },
    focusField (field) {
      this.$nextTick(() => {
        if (this.$refs[field]) {
          this.$refs[field].focus()
        } else {
          setTimeout(() => {
            if (this.$refs[field]) {
              this.$refs[field].focus()
            }
          }, 500)
        }
      })
    },
    resetForm () {
      for (let key in this.form) this.form[key] = ''
      this.deleteFlag = 0
      this.$refs.form.resetFields()
    },
    focusSubmit () {
      if (this.$parent && this.$parent.$refs.submit) {
        this.$parent.$refs.submit.$el.focus()
      }
    },
    setFocus () {
      this.setFocusElement(this, 'code1')
    }
  }
}
</script>

<style lang="stylus">
  .form-sing-up-step-code {
    .keys-wrapper {
      .el-form-item__content {
        margin 0 4rem
      }
    }
    .keys {
      display flex
      justify-content space-between
      .el-input {
        width 5rem
        .el-input__inner {
          text-align center
          font-size 2rem
        }
      }
    }

    .el-form-item {
      padding-right .5rem
      padding-left .5rem
    }

    .el-form-item__label {
      width 100%
      color #1b2138
      font-size 1.7rem
      font-weight 400
      text-align center
      line-height 1.2
      margin 0
      padding 1rem 0 1.5rem
      text-transform none

      &:before {
        display none
      }
    }

  }
</style>
